<template lang="html">
  <Prompt v-hammer:tap="showOverlay">
    <transition name="fade" enter-active-class="fadeInDown" leave-active-class="fadeOutUp">
      <Overlay v-if="overlay"></Overlay>
    </transition>
  </Prompt>
</template>
<script>
  import Prompt from '../Prompt.vue'
  import Overlay from './Overlay.vue'
  export default {
    methods: {
      showOverlay() {
        this.$store.dispatch('addToHomescreen/showOverlay')
        document.body.scrollTop = -1
      }
    },
    computed: {
      overlay() {
        return this.$store.state.addToHomescreen.overlay
      }
    },
    components: {
      Prompt,
      Overlay
    }
  }
</script>
<style lang="scss">
</style>